import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { Stepper } from '../../../../../../common/inputs/stepper/Stepper'
import { ObjectDetailsScreenValidationResult } from '../../../../../../../@types/validation-types'

const MinRentalTime: React.FC<FieldProps<ObjectDetailsScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName,
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <Stepper
        id='min-rental-time'
        propertyName='minRentalTime'
        label={t('wizard.screen.objectDetails.minRentalTime')}
        placeholder={t('wizard.screen.objectDetails.placeholder.months')}
        input={insertionData.minRentalTime}
        type='tel'
        numericOnly
        min={0}
        max={999}
        step={1}
        errors={validationMessages?.minRentalTime ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default MinRentalTime
